import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { Loader2, Lock, ArrowLeft } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Logo } from "../components/Logo";

function formatErr(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatErr(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-bg flex flex-col">
      <div className="grain" aria-hidden="true" />
      <div className="p-6 md:p-10 flex items-center justify-between">
        <Link to="/" className="text-ink"><Logo /></Link>
        <Link to="/" className="flex items-center gap-2 font-heading text-xs text-ink/50 hover:text-ink transition-colors" data-testid="admin-back-home"><ArrowLeft size={14} /> Back to site</Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-6 pb-20">
        <div className="w-full max-w-md">
          <div className="flex items-center gap-3 mb-8"><div className="w-10 h-10 border border-ink/15 flex items-center justify-center"><Lock size={16} className="text-brand-green" /></div><div><div className="overline text-brand-green">Private Access</div><h1 className="font-heading font-extrabold text-ink text-2xl tracking-tight">Enquiry Inbox</h1></div></div>
          <form onSubmit={submit} className="border border-ink/10 bg-surface p-8 space-y-6" data-testid="admin-login-form">
            {error && <div className="border border-brand-green/40 bg-brand-green/10 text-ink text-sm px-4 py-3" data-testid="admin-login-error">{error}</div>}
            <div>
              <label className="overline text-ink/40 block mb-3">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" placeholder="admin@ashutoshgroup.co.in" className="w-full bg-transparent border-b border-ink/20 focus:border-brand-green py-3 font-body text-ink placeholder:text-ink/25 outline-none transition-colors" />
            </div>
            <div>
              <label className="overline text-ink/40 block mb-3">Password</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" placeholder="••••••••" className="w-full bg-transparent border-b border-ink/20 focus:border-brand-green py-3 font-body text-ink placeholder:text-ink/25 outline-none transition-colors" />
            </div>
            <button type="submit" disabled={loading} data-testid="admin-login-btn" className="w-full inline-flex items-center justify-center gap-3 font-heading text-sm font-semibold tracking-wide bg-brand-green text-white px-9 py-4 hover:bg-ink hover:text-white transition-colors duration-300 disabled:opacity-60">
              {loading ? <><Loader2 size={16} className="animate-spin" /> Signing in…</> : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
